import axios from '../util/axiosConfig';

export const fetchPendingVisitorsAPI = async (payload) => {
    let pageNo = payload.filterRequest.page;
    let data = {
        ...payload,
        filterRequest: {
            ...payload.filterRequest,
            page: Math.max(0, (pageNo || 1) - 1),
        }
    }
    return await axios.post(`/api/v1/unverified-visits-report`, data).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false }
    })
}